export default "__VITE_ASSET__BAU6TMjl__"